import { ReactNode, createContext, useContext, useState } from 'react';

export type TDialogAction = (dialogId: string) => void;
interface IDialogContext {
  openDialog: TDialogAction;
  closeDialog: TDialogAction;
  isDialogOpen: (dialogId: string) => boolean;
}

const DialogContext = createContext<IDialogContext | null>(null);

const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [dialogs, setDialogs] = useState<Record<string, boolean>>({});

  const openDialog = (dialogId: string) => {
    setDialogs((prev) => ({ ...prev, [dialogId]: true }));
  };

  const closeDialog = (dialogId: string) => {
    setDialogs((prev) => ({ ...prev, [dialogId]: false }));
  };

  const isDialogOpen = (dialogId: string) => {
    return dialogs[dialogId] || false;
  };

  const dialogContext = {
    isDialogOpen,
    openDialog,
    closeDialog,
  };

  return <DialogContext.Provider value={dialogContext}>{children}</DialogContext.Provider>;
};

export const useDialog = () => {
  const dialogContext = useContext(DialogContext);

  if (!dialogContext) {
    throw new Error('useDialog must be used within DialogProvider');
  }

  return dialogContext;
};

export default DialogProvider;
